import { ColumnHelper } from "PFComponents/table/table.types";
import { Typography } from "PFComponents/typography";

import { isOpenVacancyItem, SuggestedWmTableItem } from "../types";
import { AvailabilityCell } from "./availability_cell";

export const createAvailabilityColumn = (
  columnHelper: ColumnHelper<SuggestedWmTableItem>,
  headerLabel: string
) =>
  columnHelper.accessor(
    (row) => (isOpenVacancyItem(row) ? undefined : (row.scores?.availabilityScore ?? undefined)),
    {
      id: "availability",
      header: () => (
        <Typography withMargin variant="labelRegular">
          {headerLabel}
        </Typography>
      ),
      cell: (info) => {
        const item = info.row.original;
        if (isOpenVacancyItem(item)) {
          return null;
        }
        return <AvailabilityCell shortlist={item} />;
      },
      sortFn: (rowA, rowB) => {
        const scoreA = isOpenVacancyItem(rowA.original) ? 0 : (rowA.original.scores?.availabilityScore ?? 0);
        const scoreB = isOpenVacancyItem(rowB.original) ? 0 : (rowB.original.scores?.availabilityScore ?? 0);
        return scoreA - scoreB;
      },
      sortUndefined: "last"
    }
  );
